import { ReadingTimeStats } from '@models/shared/readingTimeStats.type.interface';
import { IStatusType } from '@models/shared/status.type.interface';

export interface InternalLink {
  button_text: string;
  sP: string;
  sPM: string;
  section_sub_title: string;
  section_title: string;
  slug: string;
  substantivering: string;
}

export class Tip {
  _id?: string;
  title?: string;
  catSlug?: string;
  slug?: string;
  newSlug?: string;
  path?: string;
  status?: IStatusType;
  titleTag?: string;
  descTag?: string;
  content?: any;
  catName?: string;
  tagId?: number;
  tips?: boolean = true; // distinguish entity type
  how_to_schema?: any;
  mainCategory?: { slug: string };
  subCategory?: { slug: string };
  // Stats
  readingTimeStats?: ReadingTimeStats;
  viewCount?: number = 0;
  // AI image
  generatedImage?: string[];
  relatedTips?: any;
  imgAltAttribute?: string;
  internal_link?: InternalLink;
  related_tips_title?: string;
  fullUrl?: string;
}
